import { render, staticRenderFns } from "./body-table.vue?vue&type=template&id=f6f82ada&scoped=true&"
import script from "./body-table.vue?vue&type=script&lang=ts&"
export * from "./body-table.vue?vue&type=script&lang=ts&"
import style0 from "./body-table.vue?vue&type=style&index=0&id=f6f82ada&prod&lang=scss&"
import style1 from "./body-table.vue?vue&type=style&index=1&id=f6f82ada&prod&lang=scss&scoped=true&"
import style2 from "./body-table.vue?vue&type=style&index=2&id=f6f82ada&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f82ada",
  null
  
)

export default component.exports